export default __webpack_public_path__ + "pgnv-assets/06a6ad4cadfd702d1afdb9419cb10896.png";